jQuery(document).ready(function($){
	var	scrolling = false;
	var contentSections = $('.cd-section'),
		verticalNavigation = $('.cd-vertical-nav'),
		navigationItems = verticalNavigation.find('a'),
		navTrigger = $('.cd-nav-trigger'),
		scrollArrow = $('.cd-scroll-down');
	
	$(window).on('scroll', checkScroll);
	
	//smooth scroll to the selected section
	verticalNavigation.on('click', 'a', function(event){
// 		event.preventDefault(); //disable a tag link
		smoothScroll($(this.hash));
		verticalNavigation.removeClass('open');
	});
	
	//smooth scroll to the second section
	scrollArrow.on('click', function(event){
		event.preventDefault();
		smoothScroll($(this.hash));
	});
	
	// open navigation if user clicks the .cd-nav-trigger - small devices only
	navTrigger.on('click', function(event){
		event.preventDefault();
		verticalNavigation.toggleClass('open');
	});
	
	function checkScroll() {
		if( !scrolling ) {
			scrolling = true;
			(!window.requestAnimationFrame) ? setTimeout(updateSections, 300) : window.requestAnimationFrame(updateSections);
		}
	}
	
	function updateSections() {
		var halfWindowHeight = $(window).height()/2,
			scrollTop = $(window).scrollTop();
		contentSections.each(function(){
			var section = $(this),
				sectionId = section.attr('id'),
				navigationItem = navigationItems.filter('[href^="#'+ sectionId +'"]');
			( (section.offset().top - halfWindowHeight < scrollTop ) && ( section.offset().top + section.height() - halfWindowHeight > scrollTop) )
				? navigationItem.addClass('active')
				: navigationItem.removeClass('active');
		});
		scrolling = false;
	}
	
	function smoothScroll(target) {
		$('body,html').animate(
			{'scrollTop':target.offset().top},
			300
		);
	}
	
	//Custom Code - nj

// 	$('.cd-vertical-nav a[nj-class="search_article_modal"]').on('click', function(event){
// 		event.preventDefault();
//   		$('#search_article_modal').modal('show');
// 	});

// 	$('.cd-vertical-nav a[nj-class="search_product_modal"]').on('click', function(event){
// 		event.preventDefault();
//   		$('#search_product_modal').modal('show');
// 	});
  
	checkBlogOrArticle();
	function checkBlogOrArticle() {
		var path = window.location.pathname.split("/");
		if(path[3] == null) {
			var page = 'blog';
		} else {
			var page = 'article';
		}
		for(var x = 1; x <= 5; x++) {
			if(page == 'blog') {
				if(x == 1) {
					$('.cd-vertical-nav li:nth-of-type('+x+')').attr('nj-child',1);
				}
				else if(x == 2) {
					$('.cd-vertical-nav li:nth-of-type('+x+')').attr('nj-child',2);
					var link = $('.lookbook_bottom_link').attr('href');
					$('.cd-vertical-nav li:nth-of-type('+x+') a').attr('href',((link != null && link != '#') ? link : '/collections/new-product-arrivals' ));
				}
				else if(x == 3) {
					$('.cd-vertical-nav li:nth-of-type('+x+')').attr('nj-child',3);
				}
				else if(x == 4) {
					$('.cd-vertical-nav li:nth-of-type('+x+')').attr('nj-child',4);
				}
// 				else if(x == 5) {
// 					$('.cd-vertical-nav li:nth-of-type('+x+')').css('display','none');
// 				}
				else if(x == 5) {
					$('.cd-vertical-nav li:nth-of-type('+x+')').attr('nj-child',5);
				}
			} else {
				if(x == 1) {
					$('.cd-vertical-nav li:nth-of-type('+x+')').attr('nj-child',1);
				}
				else if(x == 2) {
					$('.cd-vertical-nav li:nth-of-type('+x+')').attr('nj-child',2);
					var link = $('.lookbook_bottom_link').attr('href');
					$('.cd-vertical-nav li:nth-of-type('+x+') a').attr('href',((link != null && link != '#') ? link : '/collections/new-product-arrivals' ));
					$('.cd-vertical-nav li:nth-of-type('+x+') a span').text('Shop This Lookbook');
				}
				else if(x == 3) {
					$('.cd-vertical-nav li:nth-of-type('+x+')').attr('nj-child',3);
				}
				else if(x == 4) {
					$('.cd-vertical-nav li:nth-of-type('+x+')').attr('nj-child',4);
				}
				else if(x == 5) {
					$('.cd-vertical-nav li:nth-of-type('+x+')').attr('nj-child',5);
				}
// 				else if(x == 6) {
// 					$('.cd-vertical-nav li:nth-of-type('+x+')').attr('nj-child',6);
// 				}
			}
		}
	}
});


